import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import {  IonRouterOutlet, IonSegment, IonSegmentButton, IonLabel, IonButtons, IonMenuButton } from '@ionic/angular/standalone';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-fleets',
  templateUrl: './fleets.page.html',
  styleUrls: ['./fleets.page.scss'],
  standalone: true,
  imports: [IonContent, RouterModule, IonRouterOutlet, IonHeader, IonTitle, IonToolbar, CommonModule, FormsModule, IonSegment, IonSegmentButton, IonLabel, IonButtons, IonMenuButton]
})
export class FleetsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
